import boolean from './boolean';
import segments from './segments';
import price from './price';
import distance from './distance';
import guestRating from './guestRating';

const FILTER_TYPES = {
    [boolean.id]: boolean,
    [segments.id]: segments,
    [price.id]: price,
    [distance.id]: distance,
    [guestRating.id]: guestRating
};


// TODO: Kill this once we have switched everything
export const FILTER_TYPE_NAMES = {
    [boolean.id]: boolean.id,
    [segments.id]: segments.id,
    [price.id]: price.id,
    [distance.id]: distance.id,
    [guestRating.id]: guestRating.id
};

export default FILTER_TYPES;